<!--<div class="event-status {{statusClass}}">
    <ng-container *ngIf="icon">
        <fa-icon [icon]="icon" [fixedWidth]="true"></fa-icon> {{text}}
    </ng-container>
</div>-->
<span class="badge rounded-pill {{ statusClass }}">{{ text }}</span>
